import { withSvgIcon } from './withSvgIcon';

export const Shield = withSvgIcon(
  <>
    <path
      d="M3 6L12 2L21 6C21 6 21 19 12.0001 22C2.99993 19 3 6 3 6Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M9.27638 12.5073L8.56777 11.9474L7.44326 13.3449L8.15187 13.9048L9.27638 12.5073ZM11.7193 15.5805L11.1571 16.2793C11.3579 16.4379 11.6168 16.5051 11.8696 16.4642C12.1223 16.4233 12.3452 16.278 12.4827 16.0646L11.7193 15.5805ZM16.69 9.53471L17.1754 8.78142L15.6487 7.81335L15.1633 8.56664L16.69 9.53471ZM8.15187 13.9048L11.1571 16.2793L12.2816 14.8818L9.27638 12.5073L8.15187 13.9048ZM12.4827 16.0646L16.69 9.53471L15.1633 8.56664L10.956 15.0965L12.4827 16.0646Z"
      fill="currentColor"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
